import { jsx as _jsx } from "react/jsx-runtime";
import sluggedText from "pages/campaign/components/ViewMoreContentWrapper/helpers";
import DOMPurify from "dompurify";
import { S3_URL, CDN_URL } from "helpers/constants";
const useGetContent = ({ content, expandText, height, ref, }) => {
    if (typeof content === "string") {
        const allowedHosts = new Set([
            "www.youtube.com",
            "youtube.com",
            "youtu.be",
            "www.youtu.be",
            "www.youtube-nocookie.com",
            "youtube-nocookie.com",
            "player.vimeo.com",
            "www.vimeo.com",
            "vimeo.com",
        ]);
        const youtubeEmbedHosts = new Set([
            "www.youtube.com",
            "youtube.com",
        ]);
        DOMPurify.addHook("uponSanitizeAttribute", (node) => {
            var _a, _b;
            if (node.tagName.toLowerCase() === "iframe") {
                const src = node.getAttribute("src") || "";
                try {
                    const url = new URL(src);
                    if (!allowedHosts.has(url.hostname)) {
                        (_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(node);
                        return;
                    }
                    // force https
                    if (url.protocol === "http:") {
                        url.protocol = "https:";
                    }
                    // rewrite youtube.com/embed/* to youtube-nocookie.com/embed/* for old stored content
                    if (youtubeEmbedHosts.has(url.hostname) && url.pathname.startsWith("/embed/")) {
                        url.hostname = "www.youtube-nocookie.com";
                    }
                    node.setAttribute("src", url.toString());
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- surfaced by ESLint 10 migration, flagged for follow-up
                }
                catch (e) {
                    // invalid or missing src, remove child
                    (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(node);
                }
            }
        });
        let cleanHTML = DOMPurify.sanitize(content, {
            ADD_TAGS: ["iframe"],
            ADD_ATTR: ["allowfullscreen"],
        });
        if (CDN_URL && S3_URL && cleanHTML.includes(S3_URL)) {
            cleanHTML = cleanHTML.split(S3_URL).join(`${CDN_URL}/`);
        }
        return (_jsx("div", { "data-testid": sluggedText(expandText !== null && expandText !== void 0 ? expandText : "Read more"), style: { height }, className: "story-inner", ref: ref, dangerouslySetInnerHTML: { __html: cleanHTML } }));
    }
    return (_jsx("div", { "data-testid": sluggedText(expandText !== null && expandText !== void 0 ? expandText : "Read more"), style: { height }, className: "story-inner", ref: ref, children: content }));
};
export default useGetContent;
